<template>
    <div class="class">
        <a class="apply">近期课程</a>
        <div
            v-show="courses.length === 0"
            style="position:absolute;top: 200px;left: 500px;"
        >您近期没有进行学习</div>
        <ul class="ul1" v-show="courses.length > 0">
            <li v-for="(list,index) in courses" :key="index">
                <div class="join">
                    <p>{{list.courseName}}</p>
                    <p>
                        上课时间：{{list.beginTime}}
                        <span>-</span>
                        {{list.endTime}}
                    </p>
                    <p>上课地点：{{list.address}}</p>
                    <p style="color:#333;">授课教师：{{list.teacherName}}</p>
                </div>
                <el-button type="primary" v-show="list.state">已开课</el-button>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'courses',
    data() {
        return {
            courses: []
        }
    },
    created() {
        this.getData()
    },
    methods: {
        // 近期课程
        getData() {
            this.$axios
                .get(this.$managePath + '/offline/api/course/upcoming')
                .then(res => {
                    if (res.data.data.length === 0) {
                    } else if (res.data.status == 1) {
                        this.courses = res.data.data
                        this.courses.map(item => {
                            let a = item.beginTime
                            item.time = new Date(a).getTime() //开课时间
                            let now = new Date().getTime() //当前时间
                            if (parseInt(now) >= parseInt(item.time)) {
                                item.state = true
                            } else {
                                item.state = false
                            }
                        })
                    }
                })
        }
    }
}
</script>
<style scoped>
@import '../../assets/css/iconfont.css';
@import '../../assets/css/common.css';
@import '../../assets/css/index.css';
@import '../../assets/css/cms.css';
.ul1 li {
    position: relative;
}
.el-button {
    float: right;
    position: absolute;
    right: 100px;
    width: 100px;
    height: 30px;
    top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/views/mySpace/upcomingCourse.vue